// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/css/myp-top-bar.css
// module id = 6wbX
// module chunks = 1